export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const altGaming = {
  jiliGaming: {
    PirateQueen: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Pirate Queen",
      name: "Pirate Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Piratequeen.webp",
      redirectUrl: "/casino/aggapjiligaming-pirate-queen",
    },
    WildRacer: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Wild Racer",
      name: "Wild Racer",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildracer.webp",
      redirectUrl: "/casino/aggapjiligaming-wild-racer",
    },
    NekoFortune: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Neko Fortune",
      name: "Neko Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nekofortune.webp",
      redirectUrl: "/casino/aggapjiligaming-neko-fortune",
    },
    Samba: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Samba",
      name: "Samba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/samba.webp",
      redirectUrl: "/casino/aggapjiligaming-samba",
    },
    WorldCup: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "World Cup",
      name: "World Cup",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/worldcup.webp",
      redirectUrl: "/casino/aggapjiligaming-world-cup",
    },
    BonusHunter: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Bonus Hunter",
      name: "Bonus Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonushunter.webp",
      redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
    },
    JILICAISHEN: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "JILI CAISHEN",
      name: "JILI CAISHEN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jilicaishen.webp",
      redirectUrl: "/casino/aggapjiligaming-jili-caishen",
    },
    MayanEmpire: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Mayan Empire",
      name: "Mayan Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mayanempire.webp",
      redirectUrl: "/casino/aggapjiligaming-mayan-empire",
    },
    BoneFortune: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Bone Fortune",
      name: "Bone Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonefortune.webp",
      redirectUrl: "/casino/aggapjiligaming-bone-fortune",
    },
    GoldRush: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Gold Rush",
      name: "Gold Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldrush.webp",
      redirectUrl: "/casino/aggapjiligaming-gold-rush",
    },
    HappyTaxi: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Happy Taxi",
      name: "Happy Taxi",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happytaxi.webp",
      redirectUrl: "/casino/aggapjiligaming-happy-taxi",
    },
    ThorX: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Thor X",
      name: "Thor X",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ThorX.webp",
      redirectUrl: "/casino/aggapjiligaming-thor-x",
    },
    BookofGold: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Book of Gold",
      name: "Book of Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bookofgold.webp",
      redirectUrl: "/casino/aggapjiligaming-book-of-gold",
    },
    Medusa: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Medusa",
      name: "Medusa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/medusa.webp",
      redirectUrl: "/casino/aggapjiligaming-medusa",
    },
    GoGoalBingo: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Go Goal Bingo",
      name: "Go Goal Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.webp",
      redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
    },
    ColorGame: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Color Game",
      name: "Color Game",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/colorgame.webp",
      redirectUrl: "/casino/aggapjiligaming-color-game",
    },
    JackpotBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Jackpot Bingo",
      name: "Jackpot Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.webp",
      redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
    },
    LuckyBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Lucky Bingo",
      name: "Lucky Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckybingo.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
    },
    WinDrop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/windrop.webp",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    FortuneBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Fortune Bingo",
      name: "Fortune Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunebingo.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
    },
    Baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/baccarat.webp",
      redirectUrl: "/casino/aggapjiligaming-baccarat",
    },
    iRichBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "iRich Bingo",
      name: "iRich Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/iRichBingo.webp",
      redirectUrl: "/casino/aggapjiligaming-irich-bingo",
    },
    DragonTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Dragon & Tiger",
      name: "Dragon & Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Dragon_tiger.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    },
    BigSmall: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Big Small",
      name: "Big Small",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Bigsmall.webp",
      redirectUrl: "/casino/aggapjiligaming-big-small",
    },
    GoldenJoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Golden Joker",
      name: "Golden Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldenjoker.webp",
      redirectUrl: "/casino/aggapjiligaming-golden-joker",
    },
    MasterTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Master Tiger",
      name: "Master Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mastertiger.webp",
      redirectUrl: "/casino/aggapjiligaming-master-tiger",
    },
    WildAce: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Wild Ace",
      name: "Wild Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildace.webp",
      redirectUrl: "/casino/aggapjiligaming-wild-ace",
    },
    Crazy777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Crazy 777",
      name: "Crazy 777",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazy777.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy777",
    },
    DominoGo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Domino Go",
      name: "Domino Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dominogo.webp",
      redirectUrl: "/casino/aggapjiligaming-domino-go",
    },
    UltimateTexasHoldem: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Ultimate Texas Hold'em",
      name: "Ultimate Texas Hold'em",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ultimatetexasholdem.webp",
      redirectUrl: "/casino/aggapjiligaming-ultimate-texas-holdem",
    },
    KenoBonusNumber: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Keno Bonus Number",
      name: "Keno Bonus Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/kenobonusnumber.webp",
      redirectUrl: "/casino/aggapjiligaming-keno-bonus-number",
    },
    CrashCricket: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Crash Cricket",
      name: "Crash Cricket",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crashcricket.webp",
      redirectUrl: "/casino/aggapjiligaming-crash-cricket",
    },
    CrashGoal: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Crash Goal",
      name: "Crash Goal",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crashgoal.webp",
      redirectUrl: "/casino/aggapjiligaming-crash-goal",
    },
    FortuneRoulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Fortune Roulette",
      name: "Fortune Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortuneroulette.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-roulette",
    },
    CricketRoulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricketroulette.webp",
      redirectUrl: "/casino/aggapjiligaming-cricket-roulette",
    },
    SuperESabong: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Super E-Sabong",
      name: "Super E-Sabong",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/super-e-sabong.webp",
      redirectUrl: "/casino/aggapjiligaming-super-e-sabong",
    },
    ThaiHilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Thai Hilo",
      name: "Thai Hilo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/thaihilo.webp",
      redirectUrl: "/casino/aggapjiligaming-thai-hilo",
    },
    BoxingExtravaganza: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Boxing Extravaganza",
      name: "Boxing Extravaganza",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/boxingextravaganza.webp",
      redirectUrl: "/casino/aggapjiligaming-boxing-extravaganza",
    },
    JhandiMunda: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Jhandi Munda",
      name: "Jhandi Munda",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jhandimunda.webp",
      redirectUrl: "/casino/aggapjiligaming-jhandi-munda",
    },
    SuperAceScratch: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Super Ace Scratch",
      name: "Super Ace Scratch",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/superacescratch.webp",
      redirectUrl: "/casino/aggapjiligaming-super-ace-scratch",
    },
    FishPrawnCrab: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Fish Prawn Crab",
      name: "Fish Prawn Crab",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fishprawncrab.webp",
      redirectUrl: "/casino/aggapjiligaming-fish-prawn-crab",
    },
    LuckyJaguar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Lucky Jaguar",
      name: "Lucky Jaguar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckyjaguar.webp",
      redirectUrl: "/casino/aggapjiligaming-lucky-jaguar",
    },
    Shōgun: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Shōgun",
      name: "Shōgun",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/shogun.webp",
      redirectUrl: "/casino/aggapjiligaming-shogun",
    },
    MoneyPot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Money Pot",
      name: "Money Pot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/moneypot.webp",
      redirectUrl: "/casino/aggapjiligaming-money-pot",
    },
    NightfallHunting: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Nightfall Hunting",
      name: "Nightfall Hunting",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nightfallhunting.webp",
      redirectUrl: "/casino/aggapjiligaming-nightfall-hunting",
    },
    PotDragons3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "3 Pot Dragons",
      name: "3 Pot Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3potdragon.webp",
      redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
    },
    Poseidon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Poseidon",
      name: "Poseidon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/poseidon.webp",
      redirectUrl: "/casino/aggapjiligaming-poseidon",
    },
    LuckyPiggy3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "3 Lucky Piggy",
      name: "3 Lucky Piggy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3luckypiggy.webp",
      redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
    },
    EgyptsGlow: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Egypt's Glow",
      name: "Egypt's Glow",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/egyptsglow.webp",
      redirectUrl: "/casino/aggapjiligaming-egypts-glow",
    },
    PartyStar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Party Star",
      name: "Party Star",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/partystar.webp",
      redirectUrl: "/casino/aggapjiligaming-party-star",
    },
    MoneyComingExpandBets: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Money Coming Expand Bets",
      name: "Money Coming Expand Bets",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/moneycomingexpandedbets.webp",
      redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
    },
    SuperAceeluxe: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Super Ace Deluxe",
      name: "Super Ace Deluxe",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/superacedeluxe.webp",
      redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
    },
    LegacyofEgypt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/legacyofegypt.webp",
      redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
    },
    ThePigHouse: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "The Pig House",
      name: "The Pig House",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/thepighouse.webp",
      redirectUrl: "/casino/aggapjiligaming-the-pig-house",
    },
    CrazyHunter2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Crazy Hunter 2",
      name: "Crazy Hunter 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazyhunter2.webp",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter-2",
    },
    FortuneKingJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Fortune King Jackpot",
      name: "Fortune King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunekingjackpot.webp",
      redirectUrl: "/casino/aggapjiligaming-fortune-king-jackpot",
    },
    VideoPoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Video Poker",
      name: "Video Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/videopoker.webp",
      redirectUrl: "/casino/aggapjiligaming-video-poker",
    },
    CaribbeanStudPoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Caribbean Stud Poker",
      name: "Caribbean Stud Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/caribbeanstudpoker.webp",
      redirectUrl: "/casino/aggapjiligaming-caribbean-stud-poker",
    },
  },
  mac88Gaming: {
    RockPaperScissors: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/rockpaperscissors.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    },
    Boys5: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/5boys.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
    },
    JetXT: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Jet XT",
      name: "Jet XT",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/jetxt.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
    },
    Kitex: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Kitex",
      name: "Kitex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kitex.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
    },
    HiLo: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Hi Lo",
      name: "Hi Lo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/hi-lo.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
    },
    PushpaRani: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Pushpa Rani",
      name: "Pushpa Rani",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/pushparani.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    },
    BallbyBallVR: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ballbyballvr.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    },
    XRoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "X Roulette",
      name: "X Roulette",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/xroulette.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
    },
    Lucky15: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Lucky 15",
      name: "Lucky 15",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/lucky15.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
    },
    Vortex: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Vortex",
      name: "Vortex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/vortex.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
    },
    BollyKiss: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/bollykiss.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    },
    Plinko: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Plinko",
      name: "Plinko",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/plinko.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    },
    diamonds: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Diamond",
      name: "Diamond",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/diamonds.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
    },
    mines: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Mines",
      name: "Mines",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/mines.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
    },
    Limbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Limbo",
      name: "Limbo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/limbo.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
    },
    CrashX: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Crash X",
      name: "Crash X",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/crashx.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
    },
    Dice: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Dice",
      name: "Dice",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/Dice.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
    },
    AK47VR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "AK47 VR",
      name: "AK47 VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ak47vr.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
    },
    KaunBanegaCrorepatiVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Kaun Banega Crorepati VR",
      name: "Kaun Banega Crorepati VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kaunabanegacrorpativr.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    },
    CenterCardVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Center Card VR",
      name: "Center Card VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/centrecard-vr.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    // HiloVR: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: pageUrlGenerator("/alt-gaming"),
    //   alt: "Hi Lo VR",
    //   name: "Hi Lo VR",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.webp",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
    // },
    // AviatorX2: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: pageUrlGenerator("/alt-gaming"),
    //   alt: "AviatorX2",
    //   name: "AviatorX2",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.webp",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
    // },
    // K3Lottery10: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: pageUrlGenerator("/alt-gaming"),
    //   alt: "K3 Lottery 10",
    //   name: "K3 Lottery 10",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.webp",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    // },
  },
  mac88Gaminglive: {
    DayDragonTiger1: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "1 Day Dragon Tiger",
      name: "1 Day Dragon Tiger",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/1DayDragonTiger.jpg",
      redirectUrl: "/casino/aggapmac88gaming-1-day-dragon-tiger",
    },
    CardsJudgement3: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/3CardsJudgement.jpg",
      redirectUrl: "/casino/aggapmac88gaming-3-cards-judgement",
    },
    FiveCricket5: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "5 Five Cricket",
      name: "5 Five Cricket",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/5FiveCricket.jpg",
      redirectUrl: "/casino/aggapmac88gaming-5-five-cricket",
    },
    Cricket1010: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "10 - 10 cricket",
      name: "10 - 10 cricket",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/1010Cricket.jpg",
      redirectUrl: "/casino/aggapmac88gaming-10-10-cricket",
    },
    Baccarat29: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "29 Baccarat",
      name: "29 Baccarat",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/29Baccarat.jpg",
      redirectUrl: "/casino/aggapmac88gaming-29-baccarat",
    },
    Cards32A: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "32 Cards",
      name: "32 Cards",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/32CardsA.jpg",
      redirectUrl: "/casino/aggapmac88gaming-32-cards",
    },
    TeenPatti20202: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "20 20 Teenpatti 2",
      name: "20 20 Teenpatti 2",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/2020Teenpatti2.jpg",
      redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti-2",
    },
    AmarAkbarAnthony: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Amar Akbar Anthony",
      name: "Amar Akbar Anthony",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/AmarAkbarAnthony.jpg",
      redirectUrl: "/casino/aggapmac88gaming-amar-akbar-anthony",
    },
    AndarBahar: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/AndarBahar.jpg",
      redirectUrl: "/casino/aggapmac88gaming-andar-bahar",
    },
    Bacarrat: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Bacarrat",
      name: "Bacarrat",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Bacarrat.jpg",
      redirectUrl: "/casino/aggapmac88gaming-bacarrat",
    },
    BaccaratOneDay: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Baccarat One Day",
      name: "Baccarat One Day",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/BaccaratOneDay.jpg",
      redirectUrl: "/casino/aggapmac88gaming-baccarat-one-day",
    },
    BollywoodCasinoB: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Bollywood Casino B",
      name: "Bollywood Casino B",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/BollywoodCasinoB.jpg",
      redirectUrl: "/casino/aggapmac88gaming-bollywood-casino-b",
    },
    CasinoWar: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Casino War",
      name: "Casino War",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/CasinoWar.jpg",
      redirectUrl: "/casino/aggapmac88gaming-casino-war",
    },
    Centercard: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Center card",
      name: "Center card",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Centercard.jpg",
      redirectUrl: "/casino/aggapmac88gaming-center-card",
    },
    CenterCardOneDay: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Center Card One Day",
      name: "Center Card One Day",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/CenterCardOneDay.jpg",
      redirectUrl: "/casino/aggapmac88gaming-center-card-one-day",
    },
    Cricket2020: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Cricket Match 20-20",
      name: "Cricket Match 20-20",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Cricket2020.jpg",
      redirectUrl: "/casino/aggapmac88gaming-cricket-match-20-20",
    },
    DragonTiger2: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Dragon Tiger 2",
      name: "Dragon Tiger 2",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/DragonTiger2.jpg",
      redirectUrl: "/casino/aggapmac88gaming-dragon-tiger-2",
    },
    DTL: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Dragon Tiger Lion",
      name: "Dragon Tiger Lion",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/DTL.jpg",
      redirectUrl: "/casino/aggapmac88gaming-dtl",
    },
    DuskaDum: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Dus Ka Dum",
      name: "Dus Ka Dum",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/DuskaDum.jpg",
      redirectUrl: "/casino/aggapmac88gaming-dus-ka-dum",
    },
    FootBallStudio: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Football Studio",
      name: "Football Studio",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/FootBallStudio.jpg",
      redirectUrl: "/casino/aggapmac88gaming-football-studio",
    },
    HighLow: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "High Low",
      name: "High Low",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/HighLow.jpg",
      redirectUrl: "/casino/aggapmac88gaming-high-low",
    },
    instant2cardteenpatti: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Instant 2 Cards Teenpatti",
      name: "Instant 2 Cards Teenpatti",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/instant2cardteenpatti.jpg",
      redirectUrl: "/casino/aggapmac88gaming-instant-2-cards-teenpatti",
    },
    InstantWorli: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Instant worli",
      name: "Instant worli",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/InstantWorli.jpg",
      redirectUrl: "/casino/aggapmac88gaming-instant-worli",
    },
    Lottery: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Lottery",
      name: "Lottery",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Lottery.jpg",
      redirectUrl: "/casino/aggapmac88gaming-lottery",
    },
    Lucky7: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Lucky7",
      name: "Lucky7",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Lucky7.jpg",
      redirectUrl: "/casino/aggapmac88gaming-lucky7",
    },
    MuflisTeenpatti: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Muflis Teenpatti",
      name: "Muflis Teenpatti",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/MuflisTeenpatti.jpg",
      redirectUrl: "/casino/aggapmac88gaming-muflis-teenpatti",
    },
    MuflisTeenpattiOneDay: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Muflis Teenpatti One Day",
      name: "Muflis Teenpatti One Day",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/MuflisTeenpattiOneDay.jpg",
      redirectUrl: "/casino/aggapmac88gaming-muflis-teenpatti-one-day",
    },
    NoteNumber: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Note Number",
      name: "Note Number",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/NoteNumber.jpg",
      redirectUrl: "/casino/aggapmac88gaming-note-number",
    },
    OpenTeenpatti: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Open Teen patti",
      name: "Open Teen patti",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/OpenTeenpatti.jpg",
      redirectUrl: "/casino/aggapmac88gaming-open-teen-patti",
    },
    Poker: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Poker",
      name: "Poker",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Poker.jpg",
      redirectUrl: "/casino/aggapmac88gaming-6-player-poker",
    },
    Poker1day: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Poker 1-Day",
      name: "Poker 1-Day",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Poker1day.jpg",
      redirectUrl: "/casino/aggapmac88gaming-poker-1-day",
    },
    queenrace: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Queen Race",
      name: "Queen Race",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/queen-race.jpg",
      redirectUrl: "/casino/aggapmac88gaming-queen-race",
    },
    Race20: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Race 20",
      name: "Race 20",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Race20.jpg",
      redirectUrl: "/casino/aggapmac88gaming-race-20",
    },
    Raceto2nd: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Race to 2nd",
      name: "Race to 2nd",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Raceto2nd.jpg",
      redirectUrl: "/casino/aggapmac88gaming-race-to-2nd",
    },
    Raceto17: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Raceto17.jpg",
      redirectUrl: "/casino/aggapmac88gaming-race-to-17",
    },
    Roulette: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Roulette",
      name: "Roulette",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Roulette.jpg",
      redirectUrl: "/casino/aggapmac88gaming-roulette",
    },
    SicBo: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/SicBo.jpg",
      redirectUrl: "/casino/aggapmac88gaming-sic-bo",
    },
    SideBetcity: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Side Bet city",
      name: "Side Bet city",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/SideBetcity.jpg",
      redirectUrl: "/casino/aggapmac88gaming-side-bet-city",
    },
    SuperOver: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Super Over",
      name: "Super Over",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/SuperOver.jpg",
      redirectUrl: "/casino/aggapmac88gaming-super-over",
    },
    Teenpatti2020: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "20-20 Teenpatti",
      name: "20-20 Teenpatti",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Teenpatti2020.jpg",
      redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti",
    },
    TeenpattiOneDay: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Teenpatti One Day",
      name: "Teenpatti One Day",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/TeenpattiOneDay.jpg",
      redirectUrl: "/casino/aggapmac88gaming-teenpatti-one-day",
    },
    TestTeenpatti: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Test Teenpatti",
      name: "Test Teenpatti",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/TestTeenpatti.jpg",
      redirectUrl: "/casino/aggapmac88gaming-test-teenpatti",
    },
    Trio: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Trio",
      name: "Trio",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/Trio.jpg",
      redirectUrl: "/casino/aggapmac88gaming-trio",
    },
    TwoCardTeenpattiOneDay: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Two Card Teenpatti",
      name: "Two Card Teenpatti",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/TwoCardTeenpattiOneDay.jpg",
      redirectUrl: "/casino/aggapmac88gaming-two-card-teenpatti",
    },
    WorliMatka: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/alt-gaming"),
      alt: "Worli Matka",
      name: "Worli Matka",
      providerName: "Mac88 Gaming Live",
      imgUrl: "./images/alt-gaming/mac88-live/WorliMatka.jpg",
      redirectUrl: "/casino/aggapmac88gaming-worli-matka",
    },
  },
};
